import { QRFC } from "./QRFC";

export class QCopyPubRFC extends QRFC {
  constructor() {
    // this.fDirectory = null;
    super();
  }

  InitCopyPubRFC(callbackObj) {
    this.InitRemoteCall(callbackObj, "POST", true, false);
  }

  GetCallName() {
    return "qcopypub";
  }

  SetParams(org, user, destDir, srcfilename, dstfilename) {
    //this.fDirectory = destDir;

    this.AddParameter("org", org);
    this.AddParameter("user", user);

    this.AddParameter("destdir", destDir);
    this.AddParameter("srcname", srcfilename);
    this.AddParameter("dstname", dstfilename);
  }

  DoTransactionComplete(response, callBackObj) {
    var r = response;
    callBackObj.CopyPubResult(r);
  }
}
